"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var teams_pb_exports = {};
__export(teams_pb_exports, {
  CommonProperty: () => CommonProperty,
  CroProperty: () => CroProperty,
  EthProperty: () => EthProperty,
  FindTeamRequest: () => FindTeamRequest,
  FindTeamResponse: () => FindTeamResponse,
  GetBillingRequest: () => GetBillingRequest,
  GetBillingResponse: () => GetBillingResponse,
  GetTeamPlanRequest: () => GetTeamPlanRequest,
  GetTeamPlanResponse: () => GetTeamPlanResponse,
  ListTeamsRequest: () => ListTeamsRequest,
  ListTeamsResponse: () => ListTeamsResponse,
  PlanTier: () => PlanTier,
  SaveBillingRequest: () => SaveBillingRequest,
  SaveBillingResponse: () => SaveBillingResponse,
  SaveTeamRequest: () => SaveTeamRequest,
  SaveTeamResponse: () => SaveTeamResponse,
  Team: () => Team,
  TeamActiveStatus: () => TeamActiveStatus,
  TeamBilling: () => TeamBilling,
  TeamPlan: () => TeamPlan,
  TeamQueryParam: () => TeamQueryParam,
  TeamRateLimit: () => TeamRateLimit,
  TeamRateLimits: () => TeamRateLimits,
  TeamSetupStage: () => TeamSetupStage
});
module.exports = __toCommonJS(teams_pb_exports);
var import_protobuf = require("@bufbuild/protobuf");
var import_common_pb = require("./common_pb.js");
var TeamSetupStage = /* @__PURE__ */ ((TeamSetupStage2) => {
  TeamSetupStage2[TeamSetupStage2["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  TeamSetupStage2[TeamSetupStage2["CREATED"] = 1] = "CREATED";
  TeamSetupStage2[TeamSetupStage2["QUERYING"] = 2] = "QUERYING";
  TeamSetupStage2[TeamSetupStage2["CELEBRATING"] = 3] = "CELEBRATING";
  TeamSetupStage2[TeamSetupStage2["INVITING_TEAM"] = 4] = "INVITING_TEAM";
  TeamSetupStage2[TeamSetupStage2["BILLING"] = 5] = "BILLING";
  TeamSetupStage2[TeamSetupStage2["COMPLETE"] = 6] = "COMPLETE";
  return TeamSetupStage2;
})(TeamSetupStage || {});
import_protobuf.proto3.util.setEnumType(TeamSetupStage, "alchemy.teams.TeamSetupStage", [
  { no: 0, name: "TEAM_SETUP_STAGE_UNSPECIFIED" },
  { no: 1, name: "TEAM_SETUP_STAGE_CREATED" },
  { no: 2, name: "TEAM_SETUP_STAGE_QUERYING" },
  { no: 3, name: "TEAM_SETUP_STAGE_CELEBRATING" },
  { no: 4, name: "TEAM_SETUP_STAGE_INVITING_TEAM" },
  { no: 5, name: "TEAM_SETUP_STAGE_BILLING" },
  { no: 6, name: "TEAM_SETUP_STAGE_COMPLETE" }
]);
var TeamActiveStatus = /* @__PURE__ */ ((TeamActiveStatus2) => {
  TeamActiveStatus2[TeamActiveStatus2["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  TeamActiveStatus2[TeamActiveStatus2["ACTIVE"] = 1] = "ACTIVE";
  TeamActiveStatus2[TeamActiveStatus2["INACTIVE"] = 2] = "INACTIVE";
  return TeamActiveStatus2;
})(TeamActiveStatus || {});
import_protobuf.proto3.util.setEnumType(TeamActiveStatus, "alchemy.teams.TeamActiveStatus", [
  { no: 0, name: "TEAM_ACTIVE_STATUS_UNSPECIFIED" },
  { no: 1, name: "TEAM_ACTIVE_STATUS_ACTIVE" },
  { no: 2, name: "TEAM_ACTIVE_STATUS_INACTIVE" }
]);
var PlanTier = /* @__PURE__ */ ((PlanTier2) => {
  PlanTier2[PlanTier2["PLAN_TIER_UNSPECIFIED"] = 0] = "PLAN_TIER_UNSPECIFIED";
  PlanTier2[PlanTier2["FREE"] = 1] = "FREE";
  PlanTier2[PlanTier2["ENTERPRISE"] = 3] = "ENTERPRISE";
  PlanTier2[PlanTier2["OTHER"] = 4] = "OTHER";
  PlanTier2[PlanTier2["PAYG"] = 6] = "PAYG";
  PlanTier2[PlanTier2["GROWTH"] = 2] = "GROWTH";
  PlanTier2[PlanTier2["SCALE"] = 5] = "SCALE";
  return PlanTier2;
})(PlanTier || {});
import_protobuf.proto3.util.setEnumType(PlanTier, "alchemy.teams.PlanTier", [
  { no: 0, name: "PLAN_TIER_UNSPECIFIED" },
  { no: 1, name: "FREE" },
  { no: 3, name: "ENTERPRISE" },
  { no: 4, name: "OTHER" },
  { no: 6, name: "PAYG" },
  { no: 2, name: "GROWTH" },
  { no: 5, name: "SCALE" }
]);
const _TeamQueryParam = class _TeamQueryParam extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from oneof alchemy.teams.TeamQueryParam.param
     */
    this.param = { case: void 0 };
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _TeamQueryParam().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _TeamQueryParam().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _TeamQueryParam().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_TeamQueryParam, a, b);
  }
};
_TeamQueryParam.runtime = import_protobuf.proto3;
_TeamQueryParam.typeName = "alchemy.teams.TeamQueryParam";
_TeamQueryParam.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "plan_tier", kind: "enum", T: import_protobuf.proto3.getEnumType(PlanTier), oneof: "param" }
]);
let TeamQueryParam = _TeamQueryParam;
const _ListTeamsRequest = class _ListTeamsRequest extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * Multiple params of the same kind are OR'd together (ie "IN (x, y z)")
     * params of different kinds are AND'd. Not about to make a whole recursive
     * DSL for every possible desired query at this point.
     *
     * @generated from field: repeated alchemy.teams.TeamQueryParam query_param = 1;
     */
    this.queryParam = [];
    /**
     * @generated from field: int32 page_size = 100;
     */
    this.pageSize = 0;
    /**
     * @generated from field: string pagination_token = 101;
     */
    this.paginationToken = "";
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _ListTeamsRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _ListTeamsRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _ListTeamsRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_ListTeamsRequest, a, b);
  }
};
_ListTeamsRequest.runtime = import_protobuf.proto3;
_ListTeamsRequest.typeName = "alchemy.teams.ListTeamsRequest";
_ListTeamsRequest.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "query_param", kind: "message", T: TeamQueryParam, repeated: true },
  {
    no: 100,
    name: "page_size",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 101,
    name: "pagination_token",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let ListTeamsRequest = _ListTeamsRequest;
const _ListTeamsResponse = class _ListTeamsResponse extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated alchemy.teams.Team team = 1;
     */
    this.team = [];
    /**
     * @generated from field: string next_page_token = 100;
     */
    this.nextPageToken = "";
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _ListTeamsResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _ListTeamsResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _ListTeamsResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_ListTeamsResponse, a, b);
  }
};
_ListTeamsResponse.runtime = import_protobuf.proto3;
_ListTeamsResponse.typeName = "alchemy.teams.ListTeamsResponse";
_ListTeamsResponse.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "team", kind: "message", T: Team, repeated: true },
  {
    no: 100,
    name: "next_page_token",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]);
let ListTeamsResponse = _ListTeamsResponse;
const _GetTeamPlanRequest = class _GetTeamPlanRequest extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int64 team_id = 1;
     */
    this.teamId = import_protobuf.protoInt64.zero;
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetTeamPlanRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetTeamPlanRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetTeamPlanRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_GetTeamPlanRequest, a, b);
  }
};
_GetTeamPlanRequest.runtime = import_protobuf.proto3;
_GetTeamPlanRequest.typeName = "alchemy.teams.GetTeamPlanRequest";
_GetTeamPlanRequest.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
let GetTeamPlanRequest = _GetTeamPlanRequest;
const _GetTeamPlanResponse = class _GetTeamPlanResponse extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetTeamPlanResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetTeamPlanResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetTeamPlanResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_GetTeamPlanResponse, a, b);
  }
};
_GetTeamPlanResponse.runtime = import_protobuf.proto3;
_GetTeamPlanResponse.typeName = "alchemy.teams.GetTeamPlanResponse";
_GetTeamPlanResponse.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "team_plan", kind: "message", T: TeamPlan }
]);
let GetTeamPlanResponse = _GetTeamPlanResponse;
const _SaveTeamRequest = class _SaveTeamRequest extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SaveTeamRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SaveTeamRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SaveTeamRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_SaveTeamRequest, a, b);
  }
};
_SaveTeamRequest.runtime = import_protobuf.proto3;
_SaveTeamRequest.typeName = "alchemy.teams.SaveTeamRequest";
_SaveTeamRequest.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "team", kind: "message", T: Team },
  { no: 2, name: "update_mask", kind: "message", T: import_protobuf.FieldMask }
]);
let SaveTeamRequest = _SaveTeamRequest;
const _SaveTeamResponse = class _SaveTeamResponse extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SaveTeamResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SaveTeamResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SaveTeamResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_SaveTeamResponse, a, b);
  }
};
_SaveTeamResponse.runtime = import_protobuf.proto3;
_SaveTeamResponse.typeName = "alchemy.teams.SaveTeamResponse";
_SaveTeamResponse.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "team", kind: "message", T: Team }
]);
let SaveTeamResponse = _SaveTeamResponse;
const _FindTeamRequest = class _FindTeamRequest extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from oneof alchemy.teams.FindTeamRequest.lookup_by
     */
    this.lookupBy = { case: void 0 };
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _FindTeamRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _FindTeamRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _FindTeamRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_FindTeamRequest, a, b);
  }
};
_FindTeamRequest.runtime = import_protobuf.proto3;
_FindTeamRequest.typeName = "alchemy.teams.FindTeamRequest";
_FindTeamRequest.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "id", kind: "scalar", T: 3, oneof: "lookup_by" },
  { no: 2, name: "ext_id", kind: "scalar", T: 9, oneof: "lookup_by" },
  { no: 3, name: "auth_token", kind: "scalar", T: 9, oneof: "lookup_by" }
]);
let FindTeamRequest = _FindTeamRequest;
const _FindTeamResponse = class _FindTeamResponse extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _FindTeamResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _FindTeamResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _FindTeamResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_FindTeamResponse, a, b);
  }
};
_FindTeamResponse.runtime = import_protobuf.proto3;
_FindTeamResponse.typeName = "alchemy.teams.FindTeamResponse";
_FindTeamResponse.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "team", kind: "message", T: Team }
]);
let FindTeamResponse = _FindTeamResponse;
const _GetBillingRequest = class _GetBillingRequest extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int64 team_id = 1;
     */
    this.teamId = import_protobuf.protoInt64.zero;
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetBillingRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetBillingRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetBillingRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_GetBillingRequest, a, b);
  }
};
_GetBillingRequest.runtime = import_protobuf.proto3;
_GetBillingRequest.typeName = "alchemy.teams.GetBillingRequest";
_GetBillingRequest.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  }
]);
let GetBillingRequest = _GetBillingRequest;
const _GetBillingResponse = class _GetBillingResponse extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _GetBillingResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _GetBillingResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _GetBillingResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_GetBillingResponse, a, b);
  }
};
_GetBillingResponse.runtime = import_protobuf.proto3;
_GetBillingResponse.typeName = "alchemy.teams.GetBillingResponse";
_GetBillingResponse.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "billing", kind: "message", T: TeamBilling }
]);
let GetBillingResponse = _GetBillingResponse;
const _SaveBillingRequest = class _SaveBillingRequest extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int64 team_id = 1;
     */
    this.teamId = import_protobuf.protoInt64.zero;
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SaveBillingRequest().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SaveBillingRequest().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SaveBillingRequest().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_SaveBillingRequest, a, b);
  }
};
_SaveBillingRequest.runtime = import_protobuf.proto3;
_SaveBillingRequest.typeName = "alchemy.teams.SaveBillingRequest";
_SaveBillingRequest.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  { no: 2, name: "billing", kind: "message", T: TeamBilling },
  { no: 3, name: "update_mask", kind: "message", T: import_protobuf.FieldMask }
]);
let SaveBillingRequest = _SaveBillingRequest;
const _SaveBillingResponse = class _SaveBillingResponse extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _SaveBillingResponse().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _SaveBillingResponse().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _SaveBillingResponse().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_SaveBillingResponse, a, b);
  }
};
_SaveBillingResponse.runtime = import_protobuf.proto3;
_SaveBillingResponse.typeName = "alchemy.teams.SaveBillingResponse";
_SaveBillingResponse.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "billing", kind: "message", T: TeamBilling }
]);
let SaveBillingResponse = _SaveBillingResponse;
const _Team = class _Team extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int64 id = 1;
     */
    this.id = import_protobuf.protoInt64.zero;
    /**
     * @generated from field: string ext_id = 2;
     */
    this.extId = "";
    /**
     * @generated from field: string name = 3;
     */
    this.name = "";
    /**
     * @generated from field: string auth_token = 4;
     */
    this.authToken = "";
    /**
     * @generated from field: int32 app_limit = 5;
     */
    this.appLimit = 0;
    /**
     * @generated from field: string support_channel_url = 6;
     */
    this.supportChannelUrl = "";
    /**
     * @generated from field: alchemy.teams.TeamSetupStage setup_stage = 7;
     */
    this.setupStage = 0 /* UNSPECIFIED */;
    /**
     * @generated from field: alchemy.teams.TeamActiveStatus active_status = 8;
     */
    this.activeStatus = 0 /* UNSPECIFIED */;
    /**
     * @generated from field: int32 concurrent_request_limit = 9;
     */
    this.concurrentRequestLimit = 0;
    /**
     * @generated from field: int64 cups_limit = 10;
     */
    this.cupsLimit = import_protobuf.protoInt64.zero;
    /**
     * @generated from field: int32 session_inactivity_timeout_seconds = 12;
     */
    this.sessionInactivityTimeoutSeconds = 0;
    /**
     * @generated from field: int32 session_absolute_timeout_seconds = 13;
     */
    this.sessionAbsoluteTimeoutSeconds = 0;
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _Team().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _Team().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _Team().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_Team, a, b);
  }
};
_Team.runtime = import_protobuf.proto3;
_Team.typeName = "alchemy.teams.Team";
_Team.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 2,
    name: "ext_id",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 3,
    name: "name",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "auth_token",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "app_limit",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 6,
    name: "support_channel_url",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 7, name: "setup_stage", kind: "enum", T: import_protobuf.proto3.getEnumType(TeamSetupStage) },
  { no: 8, name: "active_status", kind: "enum", T: import_protobuf.proto3.getEnumType(TeamActiveStatus) },
  {
    no: 9,
    name: "concurrent_request_limit",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 10,
    name: "cups_limit",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  { no: 11, name: "team_rate_limits", kind: "message", T: TeamRateLimits },
  {
    no: 12,
    name: "session_inactivity_timeout_seconds",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  {
    no: 13,
    name: "session_absolute_timeout_seconds",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  { no: 97, name: "created_at", kind: "message", T: import_protobuf.Timestamp },
  { no: 98, name: "updated_at", kind: "message", T: import_protobuf.Timestamp },
  { no: 99, name: "deleted_at", kind: "message", T: import_protobuf.Timestamp },
  { no: 1e3, name: "common_props", kind: "message", T: CommonProperty },
  { no: 2e3, name: "eth_props", kind: "message", T: EthProperty },
  { no: 3e3, name: "cro_props", kind: "message", T: CroProperty }
]);
let Team = _Team;
const _TeamBilling = class _TeamBilling extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: bool rate_limit_alert_acknowledged = 1;
     */
    this.rateLimitAlertAcknowledged = false;
    /**
     * @generated from field: int32 free_trial_duration_days = 5;
     */
    this.freeTrialDurationDays = 0;
    /**
     * @generated from field: string referral_token = 9;
     */
    this.referralToken = "";
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _TeamBilling().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _TeamBilling().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _TeamBilling().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_TeamBilling, a, b);
  }
};
_TeamBilling.runtime = import_protobuf.proto3;
_TeamBilling.typeName = "alchemy.teams.TeamBilling";
_TeamBilling.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "rate_limit_alert_acknowledged",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  },
  { no: 2, name: "prepaid_monthly_compute_units", kind: "message", T: import_protobuf.Int64Value },
  { no: 3, name: "monthly_price", kind: "message", T: import_protobuf.Int32Value },
  { no: 4, name: "discounted_monthly_price", kind: "message", T: import_protobuf.Int32Value },
  {
    no: 5,
    name: "free_trial_duration_days",
    kind: "scalar",
    T: 5
    /* ScalarType.INT32 */
  },
  { no: 6, name: "free_trial_last_sent_message_type", kind: "message", T: import_protobuf.Int32Value },
  { no: 7, name: "expiry_time", kind: "message", T: import_protobuf.Timestamp },
  { no: 8, name: "free_trial_start_time", kind: "message", T: import_protobuf.Timestamp },
  {
    no: 9,
    name: "referral_token",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 10, name: "referred_by", kind: "message", T: import_protobuf.StringValue },
  { no: 11, name: "referred_by_affiliate", kind: "message", T: import_protobuf.StringValue },
  { no: 12, name: "referral_awarded", kind: "message", T: import_protobuf.Timestamp }
]);
let TeamBilling = _TeamBilling;
const _CommonProperty = class _CommonProperty extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * Placeholder as an example of a repeated property for testing. Can remove when we can use an actual property.
     *
     * @generated from field: repeated google.protobuf.Int64Value test_repeated_prop = 998;
     */
    this.testRepeatedProp = [];
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CommonProperty().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CommonProperty().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CommonProperty().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_CommonProperty, a, b);
  }
};
_CommonProperty.runtime = import_protobuf.proto3;
_CommonProperty.typeName = "alchemy.teams.CommonProperty";
_CommonProperty.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 998, name: "test_repeated_prop", kind: "message", T: import_protobuf.Int64Value, repeated: true },
  { no: 999, name: "test_prop", kind: "message", T: import_protobuf.BoolValue }
]);
let CommonProperty = _CommonProperty;
const _EthProperty = class _EthProperty extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _EthProperty().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _EthProperty().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _EthProperty().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_EthProperty, a, b);
  }
};
_EthProperty.runtime = import_protobuf.proto3;
_EthProperty.typeName = "alchemy.teams.EthProperty";
_EthProperty.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "fcups_limit", kind: "message", T: import_protobuf.Int64Value },
  { no: 2, name: "getlogs_block_range_limit", kind: "message", T: import_protobuf.Int32Value }
]);
let EthProperty = _EthProperty;
const _CroProperty = class _CroProperty extends import_protobuf.Message {
  constructor(data) {
    super();
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _CroProperty().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _CroProperty().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _CroProperty().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_CroProperty, a, b);
  }
};
_CroProperty.runtime = import_protobuf.proto3;
_CroProperty.typeName = "alchemy.teams.CroProperty";
_CroProperty.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "fcups_limit", kind: "message", T: import_protobuf.Int64Value }
]);
let CroProperty = _CroProperty;
const _TeamPlan = class _TeamPlan extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int64 team_id = 1;
     */
    this.teamId = import_protobuf.protoInt64.zero;
    /**
     * @generated from field: alchemy.teams.PlanTier tier = 2;
     */
    this.tier = 0 /* PLAN_TIER_UNSPECIFIED */;
    /**
     * @generated from field: int64 customer_id = 3;
     */
    this.customerId = import_protobuf.protoInt64.zero;
    /**
     * @generated from field: int64 subscription_id = 4;
     */
    this.subscriptionId = import_protobuf.protoInt64.zero;
    /**
     * @generated from field: bool has_payment_profile = 5;
     */
    this.hasPaymentProfile = false;
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _TeamPlan().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _TeamPlan().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _TeamPlan().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_TeamPlan, a, b);
  }
};
_TeamPlan.runtime = import_protobuf.proto3;
_TeamPlan.typeName = "alchemy.teams.TeamPlan";
_TeamPlan.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "team_id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  { no: 2, name: "tier", kind: "enum", T: import_protobuf.proto3.getEnumType(PlanTier) },
  {
    no: 3,
    name: "customer_id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 4,
    name: "subscription_id",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  {
    no: 5,
    name: "has_payment_profile",
    kind: "scalar",
    T: 8
    /* ScalarType.BOOL */
  }
]);
let TeamPlan = _TeamPlan;
const _TeamRateLimits = class _TeamRateLimits extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: repeated alchemy.teams.TeamRateLimit team_rate_limits = 1;
     */
    this.teamRateLimits = [];
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _TeamRateLimits().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _TeamRateLimits().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _TeamRateLimits().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_TeamRateLimits, a, b);
  }
};
_TeamRateLimits.runtime = import_protobuf.proto3;
_TeamRateLimits.typeName = "alchemy.teams.TeamRateLimits";
_TeamRateLimits.fields = import_protobuf.proto3.util.newFieldList(() => [
  { no: 1, name: "team_rate_limits", kind: "message", T: TeamRateLimit, repeated: true }
]);
let TeamRateLimits = _TeamRateLimits;
const _TeamRateLimit = class _TeamRateLimit extends import_protobuf.Message {
  constructor(data) {
    super();
    /**
     * @generated from field: int64 cups_limit = 1;
     */
    this.cupsLimit = import_protobuf.protoInt64.zero;
    import_protobuf.proto3.util.initPartial(data, this);
  }
  static fromBinary(bytes, options) {
    return new _TeamRateLimit().fromBinary(bytes, options);
  }
  static fromJson(jsonValue, options) {
    return new _TeamRateLimit().fromJson(jsonValue, options);
  }
  static fromJsonString(jsonString, options) {
    return new _TeamRateLimit().fromJsonString(jsonString, options);
  }
  static equals(a, b) {
    return import_protobuf.proto3.util.equals(_TeamRateLimit, a, b);
  }
};
_TeamRateLimit.runtime = import_protobuf.proto3;
_TeamRateLimit.typeName = "alchemy.teams.TeamRateLimit";
_TeamRateLimit.fields = import_protobuf.proto3.util.newFieldList(() => [
  {
    no: 1,
    name: "cups_limit",
    kind: "scalar",
    T: 3
    /* ScalarType.INT64 */
  },
  { no: 2, name: "app_id", kind: "scalar", T: 3, opt: true },
  { no: 3, name: "method", kind: "scalar", T: 9, opt: true },
  { no: 4, name: "network", kind: "message", T: import_common_pb.NetworkIdentifier, opt: true }
]);
let TeamRateLimit = _TeamRateLimit;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CommonProperty,
  CroProperty,
  EthProperty,
  FindTeamRequest,
  FindTeamResponse,
  GetBillingRequest,
  GetBillingResponse,
  GetTeamPlanRequest,
  GetTeamPlanResponse,
  ListTeamsRequest,
  ListTeamsResponse,
  PlanTier,
  SaveBillingRequest,
  SaveBillingResponse,
  SaveTeamRequest,
  SaveTeamResponse,
  Team,
  TeamActiveStatus,
  TeamBilling,
  TeamPlan,
  TeamQueryParam,
  TeamRateLimit,
  TeamRateLimits,
  TeamSetupStage
});
